// PendingOrders.js
import React, { useEffect, useState } from "react";
import { Table, Spin, message, Typography, Tag } from "antd";
import axios from "axios";
import SummaryApi from "../../../common/index";

const { Title } = Typography;

function PendingOrders({ seller, token }) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchPendingOrders();
  }, []);

  const fetchPendingOrders = async () => {
    setLoading(true);
    try {
      console.log(SummaryApi.getPendingOrders.url);
      const response = await axios.get(SummaryApi.getPendingOrders.url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        // params not needed if backend uses req.seller.id
      });
      setOrders(response.data.orders || []);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch pending orders");
    }
    setLoading(false);
  };

  const columns = [
    {
      title: "Order ID",
      dataIndex: "id",
      key: "id",
      render: (id) => id || "N/A",
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name", // If backend doesn't send this, fallback to userId
      key: "customer_name",
      render: (_, record) => record.customer_name || `User ${record.userId || "-"}`,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => `₹${Number(amount || 0).toFixed(2)}`,
    },
    {
      title: "Order Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (date) => (date ? new Date(date).toLocaleString() : "-"),
    },
    {
      title: "Payment Status",
      dataIndex: "payment_status",
      key: "payment_status",
      render: (status) => (
        <Tag color={status === "pending" ? "orange" : "green"}>
          {status || "N/A"}
        </Tag>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => <Tag color="blue">{status || "N/A"}</Tag>,
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Title level={3} style={{ marginBottom: "20px" }}>
        Pending Orders
      </Title>
      {loading ? (
        <Spin tip="Loading pending orders..." size="large" />
      ) : (
        <Table
          dataSource={orders}
          columns={columns}
          rowKey="id"
          pagination={{ pageSize: 10 }}
        />
      )}
    </div>
  );
}

export default PendingOrders;
